var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowSlideLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-navigate-next"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.6046 14.4792C30.7977 14.6719 30.951 14.9009 31.0555 15.1529C31.1601 15.4049 31.2139 15.6751 31.2139 15.9479C31.2139 16.2208 31.1601 16.491 31.0555 16.743C30.951 16.995 30.7977 17.224 30.6046 17.4167L22.5213 25.5L30.6046 33.5834C30.9941 33.9729 31.213 34.5012 31.213 35.0521C31.213 35.603 30.9941 36.1313 30.6046 36.5209C30.2151 36.9104 29.6867 37.1292 29.1359 37.1292C28.585 37.1292 28.0566 36.9104 27.6671 36.5209L18.1046 26.9584C17.9115 26.7656 17.7583 26.5367 17.6537 26.2847C17.5492 26.0326 17.4954 25.7625 17.4954 25.4896C17.4954 25.2168 17.5492 24.9466 17.6537 24.6946C17.7583 24.4425 17.9115 24.2136 18.1046 24.0209L27.6671 14.4584C28.4588 13.6667 29.7921 13.6667 30.6046 14.4792Z",
    fill: "#004F9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSlideLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_slide_left.4bb65372d8f45551a10d8f692e924bd1.svg";
export { ForwardRef as ReactComponent };